import { updateCanvas } from '../../actions/ts_canvas_actions.js';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
var cStep = -1;
var cPushArray = new Array();
"use strict";
function _interopRequireDefault(e) {
  return e && e.__esModule
    ? e
    : {
      default: e
    }
}
function _classCallCheck(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function")
}
function _possibleConstructorReturn(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t
    ? e
    : t
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }),
  t && (Object.setPrototypeOf
    ? Object.setPrototypeOf(e, t)
    : e.__proto__ = t)
}

function  saveState(stateCanvas,dispatch,c){
  var canvas = stateCanvas;
  var ctx = canvas.getContext('2d');
  var idt = ctx.getImageData(0, 0, 1280, 720);
  var canvasHistory = c.history;
  canvasHistory.push(idt);
     //var count = this.state.canvasHistory.length;
  dispatch(updateCanvas(canvas,ctx,canvasHistory));
   }




Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _createClass = function() {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1,
        o.configurable = !0,
        "value" in o && (o.writable = !0),
        Object.defineProperty(e, o.key, o)
      }
    }
    return function(t, n, o) {
      return n && e(t.prototype, n),
      o && e(t, o),
      t
    }
  }(),
  _react = require("react"),
  _react2 = _interopRequireDefault(_react),
  _reactDom = require("react-dom"),
  _reactDom2 = _interopRequireDefault(_reactDom),
  _propTypes = require("prop-types"),
  _propTypes2 = _interopRequireDefault(_propTypes),
  DrawableCanvas = function(e) {
    function t() {
      return _classCallCheck(this, t),
      _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
    }
    return _inherits(t, e),
    _createClass(t, [
      {
        key: "componentDidMount",
        value: function() {
          var e = _reactDom2.default.findDOMNode(this);
          e.width = e.offsetWidth,
          e.height = e.offsetHeight;
          var t = e.getContext("2d");
          this.setState({canvas: e, context: t, draw:false})
        }
      }, {
        key: "componentWillReceiveProps",
        value: function(e) {
          e.clear && this.resetCanvas()
        }
      }, {
        key: "handleOnMouseDown",
        value: function(e) {
          var n = this.state.canvas.getBoundingClientRect();
          this.state.context.beginPath(),

          t.isMobile()
            ? this.setState({lastX: e.targetTouches[0].pageX - n.left,lastY: e.targetTouches[0].pageY - n.top})
            : this.setState({lastX: e.clientX - n.left,lastY: e.clientY - n.top}),
            this.setState({drawing: !0})
        }
      }, {
        key: "handleOnMouseMove",
        value: function(e) {
          if (this.state.drawing) {
            var n = this.state.canvas.getBoundingClientRect(),
              o = this.state.lastX,
              a = this.state.lastY,
              s = void 0,
              r = void 0;

            t.isMobile()
              ? (s = e.targetTouches[0].pageX - n.left, r = e.targetTouches[0].pageY - n.top)
              : (s = e.clientX - n.left, r = e.clientY - n.top),
            this.draw(o, a, s, r),
            this.setState({lastX: s, lastY: r})
          }
        }
      }, {
        key: "handleonMouseUp",
        value: function() {
          var isTouchSupported = "ontouchend" in document;
          var a = this.state.context;
          var lastX = this.state.lastX;
          var lastY = this.state.lastY;
          a.fillStyle = this.props.brushColor;
          a.lineJoin = a.lineCap = 'round';
          a.beginPath();
          //a.font = '48px serif';
          //a.strokeText('get bodied!', lastX, lastY);
          //a.ninjaStar(lastX, lastY, 10, 10, 45 * Math.PI/180, 0, 2 * Math.PI);
                    var {dispatch,canvas,stamp} = this.props;
          var isDraw = this.state.draw;
          //console.log(isDraw);
          var img = stamp.stamp;
          var color = stamp.color;
          if (!isDraw && stamp)
          {
              //a.lineWidth=3;
              //a.fillStyle=color;
              a.font='1.5em verdana';
              var xSpot = lastX - 10;
              var ySpot = lastY + 10;
              a.fillText(img,xSpot, ySpot);
            }
          //a.strokeText(stamp.stamp, lastX, lastY);
          //a.fill(stamp.color);
          //a.ellipse(lastX, lastY, 10, 10, 45 * Math.PI/180, 0, 2 * Math.PI);
          //a.fill();
          this.setState({draw:false});
          //a.arc(lastX, lastY, 2, 0, 2*Math.PI);


          this.setState({
            drawing: !1
          })

          saveState(this.state.canvas,dispatch,canvas);
        }
      },
       {
        key: "draw",
        value: function(e, t, n, o) {
          var a = this.state.context;
          a.strokeStyle = this.props.brushColor,
          a.lineWidth = this.props.lineWidth,
          a.lineJoin = a.lineCap = 'round',
          this.setState({context: a,draw:true}),
          this.state.context.moveTo(e, t),
          this.state.context.lineTo(n, o),
          this.state.context.stroke()
        }
      }, {
        key: "resetCanvas",
        value: function() {
          var e = this.state.context.canvas.width,
            t = this.state.context.canvas.height;
          this.state.context.clearRect(0, 0, e, t)
        }
      }, {
        key: "canvasStyle",
        value: function() {
          var e = t.getDefaultStyle(),
            n = this.props.canvasStyle;
          return Object.assign({}, e, n)
        }
      }, {
        key: "render",
        value: function() {
          var {active} = this.props;

          //var isTouchSupported = "ontouchend" in document;
          var ua = navigator.userAgent;
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
          {
            if (active.stratId == null || active.stratId == undefined || active.stratId == '')
            {
              return _react2.default.createElement("canvas", {
                style: this.canvasStyle(),
                onTouchStart: this.handleOnMouseDown.bind(this),
                onTouchMove: this.handleOnMouseMove.bind(this),
                onTouchEnd: this.handleonMouseUp.bind(this),
              })
            }
            else {
              return _react2.default.createElement("canvas", {
                style: this.canvasStyle(),
              })
            }
          }
          else {
            if (active.stratId == null || active.stratId == undefined || active.stratId == '')
            {
              return _react2.default.createElement("canvas", {
                style: this.canvasStyle(),
                onMouseDown: this.handleOnMouseDown.bind(this),
                onMouseMove: this.handleOnMouseMove.bind(this),
                onMouseUp : this.handleonMouseUp.bind(this),
              })
            }
            else {
              return _react2.default.createElement("canvas", {
                style: this.canvasStyle(),
              })
            }

          }

        }
      }
    ], [
      {
        key: "getDefaultStyle",
        value: function() {
          return {
            brushColor: "#FFFF00",
            lineWidth: 4,
            cursor: "pointer",
            canvasStyle: {
              backgroundColor: "#00FFDC"
            },
            clear: !1
          }
        }
      }, {
        key: "isMobile",
        value: function() {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
      }
    ]),
    t
  }(_react2.default.Component);
DrawableCanvas.propTypes = {
  brushColor: _propTypes2.default.string,
  lineWidth: _propTypes2.default.number,
  cursor: _propTypes2.default.string,
  canvasStyle: _propTypes2.default.shape({backgroundColor: _propTypes2.default.string}),
  clear: _propTypes2.default.bool
},

exports.default= connect((state) => {
  return {canvas:state.canvas,stamp:state.stamp, active:state.active}
})(DrawableCanvas);



// WEBPACK FOOTER //
// ./src/app/containers/landing/drawable.js